/**
 * TanStack Query hooks for `last-click-attribution`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	lastClickAttributionQueryKeys,
	type CreateLastClickAttributionBody,
	type ListLastClickAttributionResponse,
	type LastClickAttributionRow,
} from "./api";

export function useLastClickAttributionList(): UseQueryResult<ListLastClickAttributionResponse, Error> {
	return useQuery({
		queryKey: lastClickAttributionQueryKeys.list(),
		queryFn: list,
	});
}

export function useLastClickAttributionCreate(): UseMutationResult<LastClickAttributionRow, Error, CreateLastClickAttributionBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: lastClickAttributionQueryKeys.all });
		},
	});
}

export function useLastClickAttributionDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: lastClickAttributionQueryKeys.all });
		},
	});
}
